import { Injectable } from '@angular/core';
import { UserAddress, UserAddressResponse } from '@lentau/address/shared/interfaces';
import { addAddressFine } from '@lentau/address/shared/helper';

@Injectable({
  providedIn: 'root',
})
export class AddressesApiParserService {
  public parseUserAddressResponse({ Body }: UserAddressResponse): UserAddress[] {
    return Body.UserAddressList.map((address: UserAddress) => addAddressFine(address));
  }
}
